import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-cvv-field" }
const _hoisted_2 = { class: "regular black" }

import { onMounted, ref } from 'vue';
import InputComponent from './InputComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCvvComponent',
  props: {
  value: {
    type: String,
    default: '',
  },
  isValid: {
    type: Boolean,
    default: true,
  },
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props




const formatted = ref<string>('');
let timeout;

function onUpdate(value: string) {
  if (value.length > props.value.length) {
    formateValue(value, false);
  } else {
    formateValue(value, true);
  }
  emit('update:value', value);
}

function formateValue(value: string, fullFormatted: boolean) {
  clearTimeout(timeout);

  if (value.length === 0) {
    formatted.value = '';
    return;
  }

  const length = value.length;
  formatted.value = value
    .split('')
    .map((it, i) => (i === length - 1 && !fullFormatted ? it : '*'))
    .join('');

  if (!fullFormatted) {
    timeout = setTimeout(() => {
      formateValue(value, true);
    }, 1000);
  }
}

onMounted(() => {
  formateValue(props.value, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InputComponent, {
      type: "cvv",
      isValid: __props.isValid,
      value: __props.value,
      "onUpdate:value": onUpdate,
      placeholder: "CVV"
    }, null, 8, ["isValid", "value"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(formatted.value), 1)
  ]))
}
}

})